import { requests } from '@/lib/axios';
import { IResponse } from '@/utils/CommonInterface';
import { tokenParam } from '../interface';

export const validateAdmin = (params:tokenParam): Promise<IResponse> => {
  return requests.post('/admin/validate-admin', params);
}


